import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeTab: 0,
  viewIndex: 1,
  clearValues: 0,
  isClientUIX: false,
  isCustomSubmitForm: false,
  loading: true,
  turnstileStatus: false,
};

const connectUiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setViewIndex: (state, action) => {
      state.viewIndex = action.payload;
    },
    incrementClearValues: (state) => {
      state.clearValues += 1;
    },
    setIsClientUIX: (state, action) => {
      state.isClientUIX = action.payload;
    },
    setIsCustomSubmitForm: (state, action) => {
      state.isCustomSubmitForm = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTurnstileStatus: (state, action) => {
      state.turnstileStatus = action.payload;
    },
  },
});

export const {
  setActiveTab,
  setViewIndex,
  incrementClearValues,
  setIsClientUIX,
  setIsCustomSubmitForm,
  setLoading,
  setTurnstileStatus,
} = connectUiSlice.actions;

export default connectUiSlice.reducer;
